import { GET_PUBLISHED_NEWS_FEED } from "services/url.service";
import { commonTransform } from "../handleTransformation";

export const newsFeedQueries = {
  getPublishedNewsFeed: {
    getUrl: ({companyId}) =>  GET_PUBLISHED_NEWS_FEED(companyId),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
};
